import { TFunc } from '../../../../../../../hooks/useNamespacedTranslation';
import React from 'react';
import FlairIcon from '../../../../../../../atomic/atoms/FlairIcon';
import { ControlledSwitchInput } from '../../../../../../../components/form/SwitchInput';
import { TicketFormValues } from '../types';

type Props = {
  t: TFunc;
  onFieldChange: (step: Partial<TicketFormValues>) => void;
  formFieldValues: TicketFormValues | null;
};

export const ShareWithManagerFormField: React.FC<
  React.PropsWithChildren<Props>
> = ({ t, onFieldChange, formFieldValues }) => {
  const handleFieldChange = (shareWithManager: boolean) => {
    onFieldChange({
      shareWithManager,
      preview: {
        ...formFieldValues?.preview,
        shareWithManager,
      },
    });
  };

  return (
    <div className="d-flex justify-content-between">
      <div className="d-flex flex-row align-items-center gap-1">
        <h5 className="h5-regular mb-0">{t('form.fields.shareWithManager')}</h5>
        <FlairIcon
          icon="alert-circle-outline"
          tooltip={t('form.fields.shareWithManagerTooltip')}
          tooltipPlacement="top"
          size="sm"
        />
      </div>
      <ControlledSwitchInput
        className="mb-0"
        onChange={handleFieldChange}
        disabled={formFieldValues?.stayAnonymous}
        checked={formFieldValues?.shareWithManager}
        name="shareWithManager"></ControlledSwitchInput>
    </div>
  );
};
